import { render, staticRenderFns } from "./FreePlay.vue?vue&type=template&id=0aebdc6e&scoped=true"
import script from "./FreePlay.vue?vue&type=script&lang=ts"
export * from "./FreePlay.vue?vue&type=script&lang=ts"
import style0 from "./FreePlay.vue?vue&type=style&index=0&id=0aebdc6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aebdc6e",
  null
  
)

export default component.exports